// extracted by mini-css-extract-plugin
export default {"wrap":"ChoiceToggleMenu_wrap__ZWRAH"};